import { ContentDataTypes, SizePropsKey } from '@news-mono/web-common'
import { AdNoticePosition } from '@news-mono/component-library'
import { layout } from '../../App.routing'
import { theNightlySmallSectionHeaderOverride } from '@news-mono/component-library'

interface InterlacedAds {
    cardsBetweenAds: number
    cardsBetweenAdsOnTablets?: number
    initialAdOffset: number
    interlacedAdSizeDefinition: SizePropsKey
}

interface CardListParams {
    data: ContentDataTypes
    heading: string
    sectionText?: string
    adNoticePosition?: AdNoticePosition
    interlacedAds?: InterlacedAds
    numbered?: boolean
    hideMedia?: boolean
}

export const cardList = ({
    data,
    heading,
    sectionText,
    adNoticePosition,
    interlacedAds,
    numbered = true,
    hideMedia,
}: CardListParams) =>
    layout.nestedComposition({
        type: 'component-overrider',
        props: {
            override: () => theNightlySmallSectionHeaderOverride,
        },
        contentAreas: {
            children: [
                layout.component({
                    type: 'juliet',
                    props: {
                        cardType: {
                            type: 'landscape',
                            format: 'landscape-common',
                        },
                        verticalSpacing: 'md',
                        removeHorizontalGutters: true,
                        hideByline: false,
                        hideMedia,
                        numbered,
                        sectionHeader: {
                            heading,
                            sectionText,
                        },
                        dataDefinitionArgs: data,
                        cardsBetweenAds: interlacedAds?.cardsBetweenAds,
                        cardsBetweenAdsOnTablets:
                            interlacedAds?.cardsBetweenAdsOnTablets,
                        initialAdOffset: interlacedAds?.initialAdOffset,
                        interlacedAdSizeDefinition:
                            interlacedAds?.interlacedAdSizeDefinition,
                        adNoticePosition,
                    },
                }),
            ],
        },
    })

export const interlacedTopStorySegment = layout.nestedComposition({
    type: 'box',
    props: {
        horizontalSpacing: 'outerMargin',
        horizontalSpacingBreakpoint: 'sm',
    },
    contentAreas: {
        main: [
            cardList({
                data: {
                    type: 'curation',
                    name: 'top-stories',
                    offset: 1,
                    pageSize: 10,
                },
                heading: 'Top stories',
                interlacedAds: {
                    cardsBetweenAds: 5,
                    // we want the ads to appear at a different index on tablet viewport
                    cardsBetweenAdsOnTablets: 6,
                    initialAdOffset: 5,
                    interlacedAdSizeDefinition:
                        'above1280MrecLeaderboardAbove768MrecBelow',
                },
                numbered: false,
                hideMedia: true,
                adNoticePosition: 'above-center',
            }),
        ],
    },
})
